<atlas-modal [size]="modalSize" [disableClose]="false" #detail [headerRef]="detailheader" [contentRef]="detailcontent"
  [showDialogActions]="false">
</atlas-modal>
<ng-template #detailheader>
  <div class="row trans-details-modal-header">
    <div class="columns medium-6">
      <h3 class="trans-detal-fund-name">
        {{ fundName$ | async }}
      </h3>
    </div>
    <div class="columns medium-6 trans-details-modal-actions">
      <atlas-button id="go-back" [variant]="'text'" [size]="sizeMedium" (click)="onBackModal()">
        < Go Back</atlas-button>
          <atlas-dropdown #transactionsDetailsDropdown="atlasDropdown" [id]="'toggle-transactions-details-export'"
            [icon]="'more_vert'" [iconSize]="sizeMedium" [placement]="dropdownPlacementLeftStart"
            [iconButtonAlt]="'More options'" [iconAriaTitle]="'More options'"
            [triggerType]="dropdownTriggerTypeIconButton">
            <atlas-menu [style.display]="'block'" [style.max-width]="'fit-content'">
              <atlas-menu-item (click)="transactionsDetailsDropdown.menu?.closeMenu($event); onExportPDFServerModal()">
                <a>Export as PDF</a>
              </atlas-menu-item>
              <atlas-menu-item (click)="transactionsDetailsDropdown.menu?.closeMenu($event); onExportCSVModal()">
                <a>Export as CSV</a>
              </atlas-menu-item>
            </atlas-menu>
          </atlas-dropdown>
    </div>
  </div>
</ng-template>
<ng-template #detailcontent>
  <div *ngIf="!!(transactionsLength$ | async) && !!(displayData$ | async)">
    <atlas-table>
      <!-- <thead atlas-table-header #header>
      </thead> -->
      <thead atlas-table-header #header>
        <tr *ngIf="country==='au'" atlas-table-row>
          <th atlas-table-header-cell *ngFor="let col of headers" [columnDef]="col">
            <strong>{{ col.displayLabel }}</strong>
          </th>
        </tr>
        <tr *ngIf="country==='nz'" atlas-table-row>
          <th atlas-table-header-cell *ngFor="let col of headersNZ" [columnDef]="col">
            <strong>{{ col.displayLabel }}</strong>
          </th>
        </tr>
      </thead>
      <tbody atlas-table-body>
        <tr halo-table-row *ngFor="let row of (displayData$ | async)?.transactions;let index=index">
          <td atlas-table-cell>
            <ng-container *ngIf="index !== 0 && firstPage$ | async">
              {{ row.date | date: 'dd/MM/yyyy':'+0000' }}
            </ng-container>
            <ng-container *ngIf="index !== (transactionsLength$ | async) - 1 && lastPage$ | async">
              {{ row.date | date: 'dd/MM/yyyy':'+0000' }}
            </ng-container>
            <ng-container *ngIf="!(firstPage$ | async) && !(lastPage$ | async)">
              {{ row.date | date: 'dd/MM/yyyy':'+0000' }}
            </ng-container>
          </td>
          <td atlas-table-cell>
            <ng-container *ngIf="firstPage$ | async">
              <ng-container *ngIf="index === 0">
                <strong class="dsp-opening-closing">{{ row.description }}</strong>
              </ng-container>
              <ng-container *ngIf="index !== 0">
                <span [haloTooltipWithArrow]="true" [haloTooltip]="row.description" haloTooltipPosition="right"
                  haloTooltipShowDelay="100" [id]="formatId(fundIndex, index, 'description')">{{ row.description
                  }}</span>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="lastPage$ | async">
              <ng-container *ngIf="index === (transactionsLength$ | async) - 1">
                <strong class="dsp-opening-closing">{{ row.description }}</strong>
              </ng-container>
              <ng-container *ngIf="index !== (transactionsLength$ | async) - 1">
                <span [haloTooltipWithArrow]="true" [haloTooltip]="row.description" haloTooltipPosition="right"
                  haloTooltipShowDelay="100" [id]="formatId(fundIndex, index, 'description')">{{ row.description
                  }}</span>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="!(firstPage$ | async) && !(lastPage$ | async)">
              <span [haloTooltipWithArrow]="true" [haloTooltip]="row.description" haloTooltipPosition="right"
                haloTooltipShowDelay="100" [id]="formatId(fundIndex, index, 'description')">{{ row.description
                }}</span>
            </ng-container>
          </td>
          <td atlas-table-cell class="mos-u-text-right dsp-numeric-font">
            <ng-container *ngIf="firstPage$ | async">
              <ng-container *ngIf="index === 0">
                <strong class="dsp-opening-closing">{{ row.amount && row.amount !== 0 ? (row.amount |
                  decimal:'$') :
                  '-' }}</strong>
              </ng-container>
              <ng-container *ngIf="index !== 0">
                {{ row.amount && row.amount !== 0 ? (row.amount | decimal:'$') : '-' }}
              </ng-container>
            </ng-container>
            <ng-container *ngIf="lastPage$ | async">
              <ng-container *ngIf="index === (transactionsLength$ | async) - 1">
                <strong class="dsp-opening-closing">{{ row.amount && row.amount !== 0 ? (row.amount |
                  decimal:'$') :
                  '-' }}</strong>
              </ng-container>
              <ng-container *ngIf="index !== (transactionsLength$ | async) - 1">
                {{ row.amount && row.amount !== 0 ? (row.amount | decimal:'$') : '-' }}
              </ng-container>
            </ng-container>
            <ng-container *ngIf="!(firstPage$ | async) && !(lastPage$ | async)">
              {{ row.amount && row.amount !== 0 ? (row.amount | decimal:'$') : '-' }}
            </ng-container>
          </td>
          <td atlas-table-cell *ngIf="country === 'nz'" class="mos-u-text-right dsp-numeric-font">
            <ng-container *ngIf="index !== 0 && (firstPage$ | async)">
              {{ row.pieTaxPaid && row.pieTaxPaid !== 0 ? (row.pieTaxPaid | decimal:'$') : '-' }}
            </ng-container>
            <ng-container *ngIf="!(firstPage$ | async) && !(lastPage$ | async)">
              {{ row.pieTaxPaid && row.pieTaxPaid !== 0 ? (row.pieTaxPaid | decimal:'$') : '-' }}
            </ng-container>
            <ng-container *ngIf="index !== (transactionsLength$ | async) - 1 && (lastPage$ | async)">
              {{ row.pieTaxPaid && row.pieTaxPaid !== 0 ? (row.pieTaxPaid | decimal:'$') : '-' }}
            </ng-container>
          </td>
          <td atlas-table-cell *ngIf="country === 'nz'" class="mos-u-text-right dsp-numeric-font">
            <ng-container *ngIf="index !== 0 && (firstPage$ | async)">
              {{ row.netAmountFundCurrency && row.netAmountFundCurrency !== 0 ? (row.netAmountFundCurrency |
              decimal:'$')
              : '-' }}
            </ng-container>
            <ng-container *ngIf="!(firstPage$ | async) && !(lastPage$ | async)">
              {{ row.netAmountFundCurrency && row.netAmountFundCurrency !== 0 ? (row.netAmountFundCurrency |
              decimal:'$')
              : '-' }}
            </ng-container>
            <ng-container *ngIf="index !== (transactionsLength$ | async) - 1 && (lastPage$ | async)">
              {{ row.netAmountFundCurrency && row.netAmountFundCurrency !== 0 ? (row.netAmountFundCurrency |
              decimal:'$')
              : '-' }}
            </ng-container>
          </td>
          <td atlas-table-cell class="mos-u-text-right dsp-numeric-font">
            <ng-container *ngIf="firstPage$ | async">
              <ng-container *ngIf="index === 0">
                <strong class="dsp-opening-closing">
                  {{ row.unitPrice && row.unitPrice !== 0 ? (row.unitPrice | decimal:'$') : '-' }}
                </strong>
              </ng-container>
              <ng-container *ngIf="index !== 0">
                {{ row.unitPrice && row.unitPrice !== 0 ? (row.unitPrice | decimal:'$') : '-' }}
              </ng-container>
            </ng-container>
            <ng-container *ngIf="lastPage$ | async">
              <ng-container *ngIf="index === (transactionsLength$ | async) - 1">
                <strong class="dsp-opening-closing">
                  {{ row.unitPrice && row.unitPrice !== 0 ? (row.unitPrice | decimal:'$') : '-' }}
                </strong>
              </ng-container>
              <ng-container *ngIf="index !== (transactionsLength$ | async) - 1">
                {{ row.unitPrice && row.unitPrice !== 0 ? (row.unitPrice | decimal:'$') : '-' }}
              </ng-container>
            </ng-container>
            <ng-container *ngIf="!(firstPage$ | async) && !(lastPage$ | async)">
              {{ row.unitPrice && row.unitPrice !== 0 ? (row.unitPrice | decimal:'$') : '-' }}
            </ng-container>
          </td>
          <td atlas-table-cell class="mos-u-text-right dsp-numeric-font">
            <ng-container *ngIf="index !== 0 && (firstPage$ | async)">
              {{ row.units && row.units !== 0 ? (row.units | decimal) : '-' }}
            </ng-container>
            <ng-container *ngIf="!(firstPage$ | async) && !(lastPage$ | async)">
              {{ row.units && row.units !== 0 ? (row.units | decimal) : '-' }}
            </ng-container>
            <ng-container *ngIf="index !== (transactionsLength$ | async) - 1 && (lastPage$ | async)">
              {{ row.units && row.units !== 0 ? (row.units | decimal) : '-' }}
            </ng-container>
          </td>
          <td atlas-table-cell class="mos-u-text-right dsp-numeric-font">
            <ng-container *ngIf="firstPage$ | async">
              <ng-container *ngIf="index === 0">
                <strong class="dsp-opening-closing">
                  {{ row.unitBalance && row.unitBalance !== 0 ? (row.unitBalance | decimal) : '-' }}
                </strong>
              </ng-container>
              <ng-container *ngIf="index !== 0">
                {{ row.unitBalance && row.unitBalance !== 0 ? (row.unitBalance | decimal) : '-' }}
              </ng-container>
            </ng-container>
            <ng-container *ngIf="lastPage$ | async">
              <ng-container *ngIf="index === (transactionsLength$ | async) - 1">
                <strong class="dsp-opening-closing">
                  {{ row.unitBalance && row.unitBalance !== 0 ? (row.unitBalance | decimal) : '-' }}
                </strong>
              </ng-container>
              <ng-container *ngIf="index !== (transactionsLength$ | async) - 1">
                {{ row.unitBalance && row.unitBalance !== 0 ? (row.unitBalance | decimal) : '-' }}
              </ng-container>
            </ng-container>
            <ng-container *ngIf="!(firstPage$ | async) && !(lastPage$ | async)">
              {{ row.unitBalance && row.unitBalance !== 0 ? (row.unitBalance | decimal) : '-' }}
            </ng-container>
          </td>
        </tr>
      </tbody>
    </atlas-table>
    <div class="mos-u-spacer--padding-top-md row">
      <div class="column pagination-container" style="justify-content: left;">
        <span>
          Showing {{
          (((pagination$ | async)?.page - 1) * (pagination$ | async)?.itemsByPage + 1)
          }} to {{
          getMin((pagination$ | async)?.page * (pagination$ | async)?.itemsByPage, (pagination$ | async)?.total)
          }} of {{ (pagination$ | async)?.total }} entries
        </span>
      </div>
      <atlas-pagination *ngIf="(pagination$ | async)?.total" (paginationInfoRequest)="onPaginate($event)"
        [paginationInfo]="pagination$ | async">
      </atlas-pagination>
    </div>
    <div class="mos-u-spacer--padding-top-sm mos-u-spacer--padding-bottom-sm">
      <span class="mos-u-footnote">* This is the latest available unit price of the date(s)
        selected.</span>
    </div>
  </div>
</ng-template>